import { render, staticRenderFns } from "./campaignMessagesModel.vue?vue&type=template&id=b8cda076&"
import script from "./campaignMessagesModel.vue?vue&type=script&lang=js&"
export * from "./campaignMessagesModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports